import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ParcelDimensionsComponent } from "../../component/shipping/parcel-dimensions.component";
import { ListingPublic } from "../../../../globalTypes/listings.types";
import { ParcelUnitsComponent } from "../../component/shipping/parcel-units.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormsModule } from "@angular/forms";

export interface ManageParcelData {
  // Define any data you want to pass to the dialog here
  parcelId: string;
  name?: string;
  width?: number;
  length?: number;
  height?: number;
  weight?: number;
  distanceUnit?: "in" | "ft" | "mm" | "cm" | "m" | "yd";
  weightUnit?: "oz" | "lb" | "g" | "kg";
  shippingProcessorParcelId?: string;
}

@Component({
  selector: 'msh-manage-parcel-dialog',
  template: `
    <div class=" p-8 min-w-[40vw] text-copy">
      <h2 class=" text-2xl font-bold mb-4">Manage Parcel</h2>
      <msh-parcel-units class="flex justify-end mr-6 mb-3" [parcel]="parcel" ></msh-parcel-units>
      <msh-parcel-dimensions [parcel]="parcel" ></msh-parcel-dimensions>
      <div class=" mt-6 flex justify-end gap-3">
        <button mat-flat-button [mat-dialog-close]="false">Cancel</button>
        <button mat-flat-button color="primary" (click)="save()">Save</button>
      </div>
    </div>
  `,
  imports: [MatDialogModule, ParcelDimensionsComponent, ParcelUnitsComponent, FormsModule],
  standalone: true,
})
export class ManageParcelDialogComponent {
  parcel: Partial<ListingPublic & {id: string, shippingProcessorParcelId: string}> = {};
  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ManageParcelDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ManageParcelData
  ) { 
    this.parcel = {
      id: data.parcelId,
      name: data.name,
      width: data.width || 0,
      length: data.length || 0,
      height: data.height || 0,
      weight: data.weight || 0,
      distanceUnit: data.distanceUnit || 'in',
      weightUnit: data.weightUnit || 'oz',
      shippingProcessorParcelId: data.shippingProcessorParcelId
    }
  }

  save(){
    if(!this.parcel.weight || !this.parcel.length || !this.parcel.width || !this.parcel.height){
      this.snackBar.open("Please fill in all parcel dimensions and weight", "Close", {duration: 3000});
      return;
    }
    this.dialogRef.close(this.parcel);
  }
} 